export function setupCanvas(canvas, w, h) {
    const dpr = window.devicePixelRatio || 1;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    return ctx;
}

export function drawDonut(canvas, tooltipEl, labels, data, palette) {
    const total = data.reduce((a, b) => a + b, 0);
    if (!total) return;
    const w    = canvas.parentElement.clientWidth || 280;
    const size = Math.min(w, 200);
    const dpr  = window.devicePixelRatio || 1;
    canvas.width        = size * dpr;
    canvas.height       = size * dpr;
    canvas.style.width  = size + 'px';
    canvas.style.height = size + 'px';
    canvas.style.display = 'block';
    canvas.style.margin  = '0 auto';
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, size, size);

    const cx = size / 2, cy = size / 2;
    const outerR = size / 2 - 6;
    const innerR = outerR * 0.58;
    const slices = [];
    let startAngle = -Math.PI / 2;
    let cumAngle   = 0;

    data.forEach((val, i) => {
        const slice    = (val / total) * 2 * Math.PI;
        const endAngle = startAngle + slice;
        ctx.beginPath();
        ctx.arc(cx, cy, outerR, startAngle, endAngle);
        ctx.arc(cx, cy, innerR, endAngle, startAngle, true);
        ctx.closePath();
        ctx.fillStyle   = palette[i % palette.length];
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth   = 1.5;
        ctx.stroke();
        slices.push({ normStart: cumAngle, normEnd: cumAngle + slice, label: labels[i], count: val });
        cumAngle   += slice;
        startAngle  = endAngle;
    });

    ctx.fillStyle    = '#262626';
    ctx.font         = `bold ${Math.round(size * 0.14)}px system-ui, sans-serif`;
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(total, cx, cy - size * 0.05);
    ctx.fillStyle = '#a3a3a3';
    ctx.font      = `${Math.round(size * 0.08)}px system-ui, sans-serif`;
    ctx.fillText('riders', cx, cy + size * 0.1);

    if (tooltipEl) {
        const handler = (e) => {
            const rect = canvas.getBoundingClientRect();
            const mx   = e.clientX - rect.left;
            const my   = e.clientY - rect.top;
            const dx   = mx - cx;
            const dy   = my - cy;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < innerR || dist > outerR) { tooltipEl.style.display = 'none'; return; }
            let angle = Math.atan2(dy, dx) + Math.PI / 2;
            if (angle < 0) angle += 2 * Math.PI;
            const hit = slices.find(s => angle >= s.normStart && angle < s.normEnd) ?? slices[slices.length - 1];
            tooltipEl.style.display = 'block';
            const _tw = tooltipEl.offsetWidth;
            tooltipEl.style.left    = (mx + 10 + _tw > canvas.parentElement.clientWidth ? mx - _tw - 10 : mx + 10) + 'px';
            tooltipEl.style.top     = (my - 28) + 'px';
            tooltipEl.textContent   = `${hit.label}: ${hit.count}`;
        };
        canvas.removeEventListener('mousemove', canvas._donutHandler);
        canvas._donutHandler = handler;
        canvas.addEventListener('mousemove',  handler);
        canvas.addEventListener('mouseleave', () => { tooltipEl.style.display = 'none'; });
    }
}
